import { useCallback } from 'react'

import * as Styled from './styled'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { Icon, Text } from 'common-components'
import { CrownIcon } from 'containers/SubSidebar/styled'
import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import Tooltip from 'components/Tooltip'

export const UpgradeToExportButton = () => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  const onClick = useCallback(() => {
    dispatch(editorThunks.openUpgradePopup('upgrade-popup'))
  }, [])

  return (
    <Tooltip
      position="bottom"
      tooltipText={translate(T.UPGRADE_TO_EXPORT_TOOLTIP)}
    >
      <Styled.UpgradeButtonWrapper onClick={onClick}>
        <Icon customSize={19} color="white" icon={<CrownIcon />} />
        {!isMobile && (
          <Text color="white" type="subtitle">
            {translate(T.EXPORT_LABEL)}
          </Text>
        )}
      </Styled.UpgradeButtonWrapper>
    </Tooltip>
  )
}
